import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const COPY = {
  privacy: {
    title: 'Privacy Policy',
    body: 'Placeholder privacy content — this page will be updated with a full privacy notice once finalized with legal counsel. Any information submitted through our contact form is used solely to respond to enquiries and is never sold or shared with third parties outside the tools required to deliver our services.',
  },
  terms: {
    title: 'Terms of Service',
    body: 'Placeholder terms of service — this page will be updated with a full terms document once finalized with legal counsel. All engagements with Digitize Intl. are governed by a signed statement of work provided to each client.',
  },
};

const LegalPage = () => {
  const location = useLocation();
  const type = location.pathname.replace('/', '') || 'privacy';
  const meta = COPY[type] || { title: type, body: 'Placeholder content.' };
  return (
    <div className="min-h-screen bg-[#050914]">
      <Navbar />
      <section className="relative pt-36 pb-24 lg:pt-44 overflow-hidden" data-testid={`legal-page-${type}`}>
        <div className="absolute inset-0 hero-mesh" />
        <div className="absolute inset-0 noise-overlay" />
        <div className="relative max-w-3xl mx-auto px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-white/50 hover:text-white text-sm mb-8 transition-colors">
            <ArrowLeft className="w-4 h-4" /> Back to home
          </Link>
          <p className="text-[11px] uppercase tracking-[0.25em] text-white/40 font-bold mb-4">Legal</p>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tighter text-white leading-[1.02]">
            {meta.title}
          </h1>
          <p className="mt-8 text-white/60 text-lg font-light leading-relaxed">{meta.body}</p>
          <p className="mt-4 text-[11px] uppercase tracking-[0.25em] text-white/30 font-bold">Placeholder · editable</p>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default LegalPage;
